const BreakpointMediaQueries = {
  // define custom breakpoints beneath each project
	MOBILE: '(max-width: 499px)',
	TABLET: '(min-width: 500px) and (max-width: 999px)',
	DESKTOP: '(min-width: 1000px)',
	FOO_1: '(max-width: 900px)',
 	FOO_2: '(min-width: 901px) and (max-width: 1199px)',
 	FOO_3: '(min-width: 1200px)',
};

const listeners = new Set();

function onChange(callback) {
  listeners.add(callback);
}

function run() {
  log('run');

  for (const [layout, mediaQuery] of Object.entries(BreakpointMediaQueries)) {
    const mql = window.matchMedia(mediaQuery);

    const callCallbacks = () => {
      for (const callback of listeners) {
        log(`change: ${layout}`);
        callback(layout);
      }
    }

    mql.addEventListener('change', event => {
      if (event.matches) {
        callCallbacks();
      }
    });

    // for initial load
    if (mql.matches) {
      callCallbacks();
    }
	}
}

function log(...message) {
  console.log(`[ResponsiveLayoutWatcher]`, ...message);
}

export const ResponsiveLayoutWatcher = {
  run,
  onChange,
};
